/*
 * @Author: mayanxia 
 * @Date: 2021-01-12 11:51:45 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2023-06-09 15:18:26
 */
<template>
    <div class="index-container">
        <a-spin :spinning="false" style="height: 100%">
            <a-row style="height: 78px" :gutter="3" class="header-row">
                <a-col :span="24" style="height: 100%">
                    <a-row style="height: 100%" :gutter="3" class="header">
                        <a-col :span="9">
                            <div style="height: 100%;" class="header-left">
                                <div class="tabs">
                                    <div class="tab" v-for="item in tabList" :key="item.key" :class="tabKey == item.key?'tab-active': ''" @click="tabKey = item.key">
                                        <label class="tab-title" >{{item.title}}</label>
                                    </div>
                                </div>
                            </div>
                        </a-col>
                        <a-col :span="6" style="height: 100%;text-align: center" class="theme-color theme-font flex-center">{{ $t('智慧水务管理平台') }}</a-col>
                        <a-col :span="9" style="text-align: right">
                            <div style="height: 100%;" class="header-right">
                                <!--<div class="right-time">
                                    <div class="time">{{time}}</div>
                                    <div class="date">{{date}}</div>
                                </div>
                                -->
                                <router-link to="/sysHome">{{ $t('系统首页') }}</router-link>
                            </div>
                        </a-col>
                    </a-row>
                </a-col>
            </a-row>
            <a-row style="height: calc(100% - 78px)">
                <a-col style="height: 100%">
                    <div class="index-main" style="height: 100%">
                        <a-row style="height: 100%;positive: relative">
                            <a-col :span="24" style="height: 100%;">
                                <a-row style="height: 100%;">
                                    <a-col :span="24" style="height: 100%;position: relative;">
                                        <div style="position: absolute;top: 0;left: 80px;z-index: 99">
                                            <device-total-top :itemList="itemList"></device-total-top>
                                        </div>
                                        <a-select style="width:100px;position: absolute;top: 20px;right: 80px;z-index: 99" v-model="systemDeviceType" placeholder="" @change="changeSystemDeviceType">
                                            <a-select-option v-for="(item,key) in systemDeviceTypeObj" :value="key" :key="key">
                                                {{item}}
                                            </a-select-option>
                                        </a-select>
                                        <div style="position: absolute;top: 60px;right: 80px;z-index: 99">
                                            <div style="width: 300px" class="search">
                                                <a-select
                                                    labelInValue
                                                    :allowClear="true"
                                                    show-search
                                                    v-model="selectedKey"
                                                    :placeholder="$t('请输入关键字进行查询')"
                                                    style="width: 300px"
                                                    :default-active-first-option="false"
                                                    option-label-prop="label"
                                                    :show-arrow="false"
                                                    :filter-option="false"
                                                    :not-found-content="null"
                                                    dropdownClassName="keyWordSearh"
                                                    @search="handleSearch"
                                                    @change="handleChange"
                                                    @popupScroll="loadMore"
                                                >
                                                <template v-if="systemDeviceType=='2'">
                                                    <a-select-option v-for="(item,index) in dataSource" :key="item.id" :value="item.id" :label="item.deviceLocation">
                                                        <div>({{index}}){{ $t('设备名称') }}:{{ item.deviceName }}</div>
                                                        <div>{{ $t('设备编号') }}:{{ item.meterid }}</div>
                                                        <div>{{ $t('安装位置') }}:{{ item.deviceLocation }}</div>
                                                        
                                                    </a-select-option>
                                                </template>
                                                <template v-else>
                                                    <a-select-option v-for="(item,index) in dataSource" 
                                                        :key="item.id" :value="item.id" :label="item.userMeterAddr" 
                                                        >
                                                        <div>({{index}}){{ $t('用户名称') }}:{{ item.userName }}</div>
                                                        <div>{{ $t('用户编号') }}:{{ item.userId }}</div>
                                                        <div>{{ $t('安装位置') }}:{{ item.userMeterAddr }}</div>
                                                        <div>{{ $t('表编号') }}:{{ item.meterId }}</div>
                                                    </a-select-option>
                                                </template>
                                                </a-select>
                                            </div>
                                        </div>
                                        <!--
                                        <echart-b-map :titleImage="titleImage"></echart-b-map>
                                        -->
                                        <div id="container" tabindex="0" style="width: 100%;height: 100%;position: fixed" ></div>
                                    </a-col>
                                </a-row>
                            </a-col>
                        </a-row>
                    </div>
                </a-col>
            </a-row>
        </a-spin>
    </div>
</template>
<script>

import { formatTime,cloneObject } from "@/utils/util"
import echartBMap from './modules/echartBMap'
import deviceTotalTop from './modules/deviceTotalTop'
import { postAction,getAction } from '@/api/manage'
import AMapLoader from '@amap/amap-jsapi-loader';
import {Mn100FkStatusObj} from '@/utils/constants/protocolConstant'
import { isUndefinedAndNull,isNull,isUndefined } from '@/utils/validate'
import axios from 'axios'

const BATCHNUM = 1000;

var markers = [];
var labelsMarker = [];
var icon = {
   // 图标类型，现阶段只支持 image 类型
   type: 'image',
   // 图片 url
   image: require('@/assets/images/meter.png'),
   // 图片尺寸
   size: [30, 30],
   // 图片相对 position 的锚点，默认为 top-left
   anchor: 'top-left',
};
var unusualIcon = {
   // 图标类型，现阶段只支持 image 类型
   type: 'image',
   // 图片 url
   image: require('@/assets/images/meterUnusual.png'),
   // 图片尺寸
   size: [30, 30],
   // 图片相对 position 的锚点，默认为 top-left
   anchor: 'top-left',
};
var text = {
    // 要展示的文字内容
    content: '',
    // 文字方向，有 icon 时为围绕文字的方向，没有 icon 时，则为相对 position 的位置
    direction: 'right',
    // 在 direction 基础上的偏移量
    offset: [0, -5],
    // 文字样式
    style: {
        // 字体大小
        fontSize: 12,
        // 字体颜色
        fillColor: '#85A9DF',
        backgroundColor: '#041741',
        padding: [5, 5, 5, 5],
        borderWidth: 3,
        borderColor: '#041741'
    }
};
var labelsLayer;

export default {
  components: { echartBMap,deviceTotalTop },
    name: "screen",
    data() {
        return {
            loading: true,
            titleImage:require("@/assets/images/title-gradual.png"),
            tabList: [{title: this.$t('一张图'), key: 'tabKey1'}],
            tabKey: 'tabKey1',
            time: '',
            date: '',
            url: {
                queryTotalCountByOrgCode: '/jeecg-charge/meter/meterUserinfo/queryTotalCountByOrgCode',
                queryMeterAddrInfoByOrgCode: '/jeecg-charge/meter/meterUserinfo/queryMeterAddrInfoByOrgCode',
                queryMeterInfoByLngAndLat: '/jeecg-charge/meter/meterUserinfo/queryMeterInfoByLngAndLat',
                queryMeterInfoAndMeterUpData: '/jeecg-charge/meter/meterUserinfo/queryMeterInfoAndMeterUpData',// 查询表具信息及最新上报数据
                queryDeviceTotalCountByOrgCode: '/pw/queryTotalCountByOrgCode',
                queryPMDeviceInfoAndDeviceUpData: '/pw/queryDeviceInfoAndDeviceUpData',
                queryPMMeterInfoByLngAndLat: '/pw/queryPMMeterInfoByLngAndLat',
                list: '/jeecg-charge/meter/meterUserinfo/queryMeterInfoAndMeterUpDataByKeyWord',
                pwlist: '/pw/queryDeviceInfoAndDeviceUpDataByKeyWord',
            },
            itemList: [
                {title: this.$t('全部'),key: 0,icon: ' iconquanbu',num: 0,enName: 'All Device'},
                {title: this.$t('水表'),key: 1,icon: ' iconshuibiao1',num: 0,enName: 'waterDevice'},
                {title: this.$t('压力'),key: 2,icon: ' iconyali',num: 0,enName: 'pressDevice'},
                {title: this.$t('液位'),key: 3,icon: ' iconyali',num: 0,enName: 'waterDevice'},
                {title: this.$t('流量'),key: 4,icon: ' iconliuliang',num: 0,enName: 'levelMeasure'},
                {title: this.$t('水质'),key: 5,icon: ' iconshuizhi1',num: 0,enName: 'waterQuality'},
                {title: this.$t('控压阀'),key: 6,icon: ' iconshuizhi1',num: 0,enName: 'ValveOPening'},
                {title: 'DMA',key: 7,icon: ' icondma',num: 0,enName: 'DMADevice'},
                {title: this.$t('停漏水'),key: 8,icon: ' icontingloushui',num: 0,enName: 'leaking'}
            ],
            map: null,
            cluster: null,
            selectedKey: undefined,
            keyWord: undefined,
            meterList: [],
            pmList: [],
            effecMeterList: [], // 经纬度信息不为空的有效信息
            dataSource: [],
            systemDeviceType: '1',
            systemDeviceTypeObj: {1: this.$t('水表'),2: this.$t('压力表')/*,3: '液位计',4:'流量计',5: '水质监测仪',6: '控压阀'*/},
            pmEffecMeterList: [], // 经纬度信息不为空的压力表信息
            waterEffecMeterList: [], // 经纬度信息不为空的水表有效信息
            /* 分页参数 */
            ipagination:{
                current: 1,
                pageSize: 3000,
                pageSizeOptions: ['10', '20', '30'],
                showTotal: (total, range) => {
                return range[0] + "-" + range[1] + " " + this.$t('共{total}条', { total: total })
                },
                showQuickJumper: true,
                showSizeChanger: true,
                total: 0
            },
            /* 搜索分页参数 */
            searchIpagination:{
                current: 1,
                pageSize: 10,
                total: 0
            },
        }
    },
    created() {
        this.setDateTime()
    },
    mounted() {
        
        this.queryTotalCountByOrgCode()
        this.loadData(1)
        this.$nextTick(() => {
            this.initAMapByLoad();
        })
    },
    methods: {
        handleSearch(value) {
            console.log("搜索")
            this.keyWord = value
            this.dataSource = []
            if(this.systemDeviceType == 2) {
                return this.loadPMData(1)
            }else{
                this.loadData(1);
            }
            
        },
        loadMore(e) {
            console.log("加载下一页");
            //e.persist();
            /**
             * const { scrollHeight, scrollTop, clientHeight } = e.targe
                if (scrollHeight - scrollTop === clientHeight) {
             */
            const { target } = e;
            if (target.scrollTop + target.offsetHeight === target.scrollHeight) {
                this.searchIpagination.current++;
                
                if(this.systemDeviceType == 2) {
                    return this.loadPMData()
                }else{
                    this.loadData();
                }
            }
            
        },
        loadData(arg) {
            /*
            let result = []
            for(let i = 0;i<this.effecMeterList.length;i++) {
                let item = this.effecMeterList[i]

                if((item.userName!==null&&item.userName.indexOf(value)>-1)||
                (item.userMeterAddr!==null&&item.userMeterAddr.indexOf(value)>-1)||
                (item.meterId!==null&&item.meterId.indexOf(value)>-1)||
                (item.userId!==null&&item.userId.indexOf(value)>-1)) {
                    result.push(item)
                }
            }
            this.dataSource = result
            */
            if(!this.url.list){
                this.$message.error(this.$t("请设置url.list属性!"))
                return
            }
            //加载数据 若传入参数1则加载第一页的内容
            if (arg === 1) {
                this.searchIpagination.current = 1;
            }
            let params = {};//查询条件
            if(this.keyWord) {
                params.keyWord = this.keyWord;
            }
            console.log("关键字："+this.keyWord)
            params.pageNo = this.searchIpagination.current;
            params.pageSize = this.searchIpagination.pageSize;
            this.loading = true;
            getAction(this.url.list, params).then((res) => {
                if (res.success) {
                    this.dataSource = this.dataSource.concat(res.result.records);
                    this.searchIpagination.total = res.result.total;
                }
                if(res.code===510){
                this.$message.warning(res.message)
                }
                this.loading = false;
            })
        },
        loadPMData(arg) {
            /*
            let result = []
            for(let i = 0;i<this.effecMeterList.length;i++) {
                let item = this.effecMeterList[i]

                if((item.deviceName!==null&&item.deviceName.indexOf(value)>-1)||
                (item.meterid!==null&&item.meterid.indexOf(value)>-1)||
                (item.deviceLocation!==null&&item.deviceLocation.indexOf(value)>-1)) {
                    result.push(item)
                }
            }
            this.dataSource = result
            */
            if(!this.url.pwlist){
                this.$message.error(this.$t("请设置url.pwlist属性!"))
                return
            }
            //加载数据 若传入参数1则加载第一页的内容
            if (arg === 1) {
                this.searchIpagination.current = 1;
            }
            let params = {};//查询条件
            if(this.keyWord) {
                params.keyWord = this.keyWord;
            }
            params.pageNo = this.searchIpagination.current;
            params.pageSize = this.searchIpagination.pageSize;
            this.loading = true;
            getAction(this.url.pwlist, params).then((res) => {
                if (res.success) {
                    this.dataSource = this.dataSource.concat(res.result.records);
                    this.searchIpagination.total = res.result.total;
                }
                if(res.code===510){
                this.$message.warning(res.message)
                }
                this.loading = false;
            })
        },
        loadWMData(arg) {
            if(!this.url.pwlist){
                this.$message.error(this.$t("请设置url.pwlist属性!"))
                return
            }
            //加载数据 若传入参数1则加载第一页的内容
            if (arg === 1) {
                this.searchIpagination.current = 1;
            }
            let params = {};//查询条件
            if(this.keyWord) {
                params.keyWord = this.keyWord;
            }
            params.pageNo = this.searchIpagination.current;
            params.pageSize = this.searchIpagination.pageSize;
            this.loading = true;
            getAction(this.url.pwlist, params).then((res) => {
                if (res.success) {
                    this.dataSource = this.dataSource.concat(res.result.records);
                    this.searchIpagination.total = res.result.total;
                }
                if(res.code===510){
                this.$message.warning(res.message)
                }
                this.loading = false;
            })
        },
        handleChange(value) {

            if(this.systemDeviceType == 2) {
                return this.handlePMChange(value)
            }
            let map = this.map;
            let lastMarkerIndex = labelsMarker.findIndex(item => item.getzIndex()>=10);
            if(lastMarkerIndex>=0) {
                let extData = labelsMarker[lastMarkerIndex].getExtData();
                let status = this.transMeterStatusInfo(extData)
                let zIndex = 1
                if(status!=='正常'&&status !== '--') {
                    // 有异常时将标记点放置在最上层显示
                    zIndex = 2
                }
                labelsMarker[lastMarkerIndex].setzIndex(zIndex);
                let singleText = cloneObject(text);
                singleText.content = extData.userMeterAddr;
                labelsMarker[lastMarkerIndex].setText(singleText);
                
            }
            
            if(isUndefined(value)) {
                //this.dataSource = this.effecMeterList;
                this.dataSource = [];
                this.keyWord = null;
                this.loadData(1);
                //labelsMarker = [];
                //labelsLayer.clear();
                //this.dealAMapMarkers(this.effecMeterList);
                if(labelsMarker.length>0) {
                    let labelMarker = labelsMarker[0];
                    map.setZoomAndCenter(17,labelMarker.getPosition());
                }
                
            }else{
                let that = this
                // 根据点击的值在地图中显示该点信息
                //let data = this.effecMeterList.filter(item => item.id === value.key)
                let index = this.effecMeterList.findIndex(item => item.id === value.key)
                console.log(index)
                console.log(this.effecMeterList)
                if(index>=0) {
                    console.log(labelsMarker)
                    let labelMarker = labelsMarker[index];
                    console.log(labelMarker)
                    let currentText = cloneObject(labelMarker.getText());
                    currentText.style.fillColor = '#31d7ff';
                    currentText.style.borderColor = '#00FAFE';
                    labelMarker.setzIndex(10);
                    labelMarker.setText(currentText);
                    map.setZoomAndCenter(17,labelMarker.getPosition());
                    
                    
                    /*
                    console.log(data)
                    this.amapConvertFrom([data[0].userMeterLng,data[0].userMeterLat]).then((resLnglat)=> {
                        console.log("转换完成")
                        map.setZoomAndCenter(17,resLnglat);
                        markers[0].setAnimation('AMAP_ANIMATION_BOUNCE');
                        //map.remove(markers)
                        //that.addAMapMarker(resLnglat,data[0])
                        //this.addAMapLabelMarker(resLnglat,data[0])
                    }).catch((e)=>{
                        console.error(e);
                    });
                    */
                }
            }
            
            //this.keyWord = value.userMeterAddr
        },
        handlePMChange(value) {
            let map = this.map;
            let lastMarkerIndex = labelsMarker.findIndex(item => item.getzIndex()>=10);
            if(lastMarkerIndex>=0) {
                let extData = labelsMarker[lastMarkerIndex].getExtData();
                let status = extData == 0?'正常':extData.datainfo
                let zIndex = 1
                if(status!=='正常'&&status !== '--') {
                    // 有异常时将标记点放置在最上层显示
                    zIndex = 2
                }
                labelsMarker[lastMarkerIndex].setzIndex(zIndex);
                let singleText = cloneObject(text);
                singleText.content = extData.userMeterAddr;
                labelsMarker[lastMarkerIndex].setText(singleText);
                
            }
            
            if(isUndefined(value)) {
                //this.dataSource = this.effecMeterList;
                this.dataSource = [];
                this.keyWord = null;
                this.loadPMData(1);
                //labelsMarker = [];
                //labelsLayer.clear();
                //this.dealAMapMarkersPM(this.effecMeterList);
                if(labelsMarker.length>0) {
                    let labelMarker = labelsMarker[0];
                    map.setZoomAndCenter(17,labelMarker.getPosition());
                }
            }else{
                let that = this
                // 根据点击的值在地图中显示该点信息
                //let data = this.effecMeterList.filter(item => item.id === value.key)
                let index = this.effecMeterList.findIndex(item => item.id === value.key)
                if(index>=0) {
                    let labelMarker = labelsMarker[index];
                    let currentText = cloneObject(labelMarker.getText());
                    currentText.style.fillColor = '#31d7ff';
                    currentText.style.borderColor = '#00FAFE';
                    labelMarker.setzIndex(10);
                    labelMarker.setText(currentText);
                    map.setZoomAndCenter(17,labelMarker.getPosition());
                }
            }
            
            //this.keyWord = value.userMeterAddr
        },
        setDateTime() {
            let time = formatTime(new Date().getTime(),'yyyy-MM-dd HH:mm:ss')
            let dateArr = time.split(' ')
            this.date = dateArr[0]
            this.time = dateArr[1]
        },
        queryTotalCountByOrgCode() {
            try {
                let that = this;
                axios.all([this.queryWaterMeterTotalCountByOrgCode(),this.queryDeviceTotalCountByOrgCode()]).then
                (axios.spread(function (val1, val2) {
                    console.log(val1.result,val2.result)
                    that.itemList[1].num = val1.result.meterUserCount;
                    that.itemList[2].num = isNull(val2.result)?0:val2.result.PMTotalCount;
                    that.itemList[3].num = isNull(val2.result)?0:val2.result.WMTotalCount;
                    that.itemList[4].num = isNull(val2.result)?0:val2.result.EmfFlowTotalCount;
                    that.itemList[5].num = isNull(val2.result)?0:val2.result.WaterQualityTotalCount;
                    that.itemList[6].num = isNull(val2.result)?0:val2.result.ValveOPeningTotalCount;
                    that.itemList[0].num = that.itemList[1].num+that.itemList[2].num+that.itemList[3].num+that.itemList[4].num+
                    that.itemList[5].num+that.itemList[6].num;
                    
                }))
            } catch (err) {
                console.log("通知异常",err);
            }
        },
        queryWaterMeterTotalCountByOrgCode() {
            return getAction(this.url.queryTotalCountByOrgCode,{})
        },
        queryDeviceTotalCountByOrgCode() {
            return getAction(this.url.queryDeviceTotalCountByOrgCode,{})
        },
        initAMapByLoad() {
            let that = this;
            AMapLoader.load({ //首次调用 load
                key:'05362cd4f6802209f097253d0d47b52b',//首次load key为必填
                //version:'2.0',
                version:'1.4.15',
                plugins:['AMap.Driving','AMap.Scale','AMap.Geocoder','AMap.ToolBar','AMap.ControlBar','AMap.DistrictSearch','AMap.MarkerCluster','AMap.MoveAnimation']
            }).then((AMap)=>{
                console.log('啦啦啦')
                that.map = new AMap.Map('container',{
                    viewMode: '3D', 
                    //center:[108.938411,34.339737],
                    resizeEnable: true,
                    rotateEnable:true,
                    pitchEnable:true,
                    zoom: 17,
                    pitch:30,
                    //rotation:-15,
                    jogEnable: false, // 地图是否使用缓动效果
                    animateEnable: false // 切换点位时，不使用动画
                });
                let map = that.map;
                that.map.on("complete", function(){
                    console.error("地图加载完成")
                    labelsLayer = new AMap.LabelsLayer({
                        zooms: [3, 20],
                        zIndex: 1000,
                        // 该层内标注是否避让
                        collision: false,
                        // 设置 allowCollision：true，可以让标注避让用户的标注
                        allowCollision: true,
                    });
                    map.add(labelsLayer);
                    that.queryMeterInfoAndMeterUpData()
                    //that.queryPMDeviceInfoAndDeviceUpData()
                });
                
                // 设置显示的要素,不显示标注point
                //map.setFeatures(['bg', 'road', 'building']);
                
                map.setMapStyle('amap://styles/8b9a8b2dc6a9a8e0727c158e743fa470');
                let controlBar = new AMap.ControlBar({
                    position: {
                        bottom: '80px',
                        right: '80px',
                    }
                });
                that.map.addControl(controlBar);
                
                /**
                    * 只显示陕西省的区域信息。其他地方的地图不展示
                    */
                /*
                new AMap.DistrictSearch({
                    extensions: 'all',
                    subdistrict: 0
                }).search('陕西省', function(status, result) {// 外多边形坐标数组和内多边形坐标数组
                    var outer = [
                        new AMap.LngLat(-360, 90, true),
                        new AMap.LngLat(-360, -90, true),
                        new AMap.LngLat(360, -90, true),
                        new AMap.LngLat(360, 90, true)
                    ]
                    var holes = result.districtList[0].boundaries
                    var pathArray = [outer]
                    pathArray.push.apply(pathArray, holes)
                    that.polygon = new AMap.Polygon({
                        pathL: pathArray,
                        strokeColor: 'red',//城市边界颜色
                        strokeWeight: 1,
                        fillColor: '#220986', // 遮罩背景色黑色
                        fillOpacity: 1
                    })
                    that.polygon.setPath(pathArray)
                    that.map.add(that.polygon)
                })
                */
            }).catch((e)=>{
                console.error(e);
            });
        },
        queryMeterInfoAndMeterUpData() {
            // 2022.05.11更新为每次查询1000个点位，多请求几次
            //this.meterList = []
            // 查看单位所安装表的坐标信息
            let params = {}
            params.pageNo = this.ipagination.current;
            params.pageSize = this.ipagination.pageSize;
            getAction(this.url.queryMeterInfoAndMeterUpData,params).then((res)=> {
                let records = res.result.records
                if(res.success&&records.length>0) {
                    this.meterList = this.meterList.concat(records)
                    let deptListNew = records.filter(item => {
                        return !isNull(item.userMeterLng)&&!isNull(item.userMeterLat)
                    })
                    this.waterEffecMeterList = this.waterEffecMeterList.concat(deptListNew);
                    this.effecMeterList = this.effecMeterList.concat(deptListNew);
                    
                    // 是否重置中心点坐标
                    let isResetCenter = false
                    if(res.result.current == 1) {
                        isResetCenter = true
                        //this.dataSource = this.dataSource.concat(deptListNew);
                    }
                    this.dealAMapMarkers(deptListNew,isResetCenter);
                    if(res.result.current<res.result.pages) {
                        this.ipagination.current++;
                        this.queryMeterInfoAndMeterUpData()
                    }else{
                        this.dealAMapMarkers(this.waterEffecMeterList,isResetCenter);
                    }
                    
                }
            })
        },
        queryPMDeviceInfoAndDeviceUpData() {
            //this.pmList = []
            // 查看单位所安装表的坐标信息
            getAction(this.url.queryPMDeviceInfoAndDeviceUpData,{}).then((res)=> {
                let records = res.result.records
                if(res.success&&records.length>0) {
                    this.pmList = this.pmList.concat(records)
                    let deptListNew = records.filter(item => {
                        return !isNull(item.longitude)&&!isNull(item.latitude)
                    })
                    this.pmEffecMeterList = this.pmEffecMeterList.concat(deptListNew);
                    this.effecMeterList = this.effecMeterList.concat(deptListNew);
                    // 是否重置中心点坐标
                    let isResetCenter = false
                    if(res.result.current == 1) {
                        isResetCenter = true
                        //this.dataSource = this.dataSource.concat(deptListNew);
                    }
                    this.dealAMapMarkersPM(deptListNew,isResetCenter);
                    if(res.result.current<res.result.pages) {
                        this.ipagination.current++;
                        this.queryPMDeviceInfoAndDeviceUpData()
                    }
                }
            })
        },
        async dealAMapMarkers(arrList,isResetCenter = true) {
            console.log("地图描点")
            let map = this.map;
            if(this.cluster!=null) {
                this.cluster.setMap(null)
            }
            let that = this
            // 处理批量转移一次转换1000个，太多会有异常
            let serNum = Math.floor(arrList.length/BATCHNUM)
            for(let i =0;i<(serNum+1);i++) {
                let convertList = []
                if(i== serNum) {
                    // 最后一组数据
                    convertList = arrList.slice(i*BATCHNUM,arrList.length)
                }else{
                    convertList = arrList.slice(i*BATCHNUM, (i+1)*BATCHNUM)
                }
                await this.amapConvertFromBatch(convertList).then((result)=> {
                    console.error("转换完成");
                    
                    let resLnglats = result.resLnglats
                    console.log(resLnglats.length)
                    if(resLnglats.length>0) {
                        // 默认将第一个点位设置为中心点
                        if(isResetCenter) {
                            map.setZoomAndCenter(17,resLnglats[0]);
                        }
                        
                        let length = resLnglats.length;
                        for(let i = 0;i<length;i++) {
                            let resLnglat = resLnglats[i]
                            that.addAMapLabelMarker(resLnglat,convertList[i])
                        }
                        console.error("点标记处理完成");
                        
                    }
                    
                }).catch((e)=>{
                    console.error(e);
                });
                console.log("全部转换完成")
            }
            console.log("循环结束")
            labelsLayer.add(labelsMarker);
        },
        dealAMapMarkersPM(arrList,isResetCenter = true) {
            let map = this.map;
            if(this.cluster!=null) {
                this.cluster.setMap(null)
            }
            let that = this
            // 处理批量转移一次转换2000个，太多会有异常
            let serNum = Math.floor(arrList.length/BATCHNUM)
            for(let i =0;i<serNum+1;i++) {
                let convertList = []
                if(i== serNum) {
                    // 最后一组数据
                    convertList = arrList.slice(i*BATCHNUM,arrList.length)
                }else{
                    convertList = arrList.slice(i*BATCHNUM, (i+1)*BATCHNUM)
                }
                this.amapConvertFromBatchPM(convertList).then((result)=> {
                    console.error("转换完成");
                    let resLnglats = result.resLnglats
                    if(resLnglats.length>0) {
                        // 默认将第一个点位设置为中心点
                        if(isResetCenter) {
                            map.setZoomAndCenter(17,resLnglats[0]);
                        }
                        let length = resLnglats.length;
                        for(let i = 0;i<length;i++) {
                            let resLnglat = resLnglats[i]
                            that.addAMapLabelMarkerPM(resLnglat,convertList[i])
                        }
                        console.error("点标记处理完成");
                        labelsLayer.add(labelsMarker);
                    }
                    
                }).catch((e)=>{
                    console.error(e);
                });
            }
        },
        amapConvertFrom(lnglat) {
            return new Promise(function(resolve,reject){
                AMap.convertFrom(lnglat, "baidu", function (status, result) {
                    if (result.info === 'ok') {
                        resolve(result.locations[0])
                    }else{
                        reject("转换出错")
                    }
                })
            })
        },
        amapConvertFromBatch(arrList) {
            let lnglats = []
            let deptListNew = arrList.filter(item => {
                return !isNull(item.userMeterLng)&&!isNull(item.userMeterLat)
            })
            let length = deptListNew.length
            for(let i = 0;i<length;i++) {
                let data = deptListNew[i]
                lnglats.push(new AMap.LngLat(data.userMeterLng,data.userMeterLat))
            }
            console.log("arrList:"+arrList.length)
            //this.effecMeterList = deptListNew
            //this.dataSource = deptListNew
            return new Promise(function(resolve,reject){
                AMap.convertFrom(lnglats, "baidu", function (status, result) {
                    if (result.info === 'ok') {
                        // resolve只能处理一个参数
                        console.log("locations:"+result.locations.length)
                        resolve({resLnglats:result.locations,deptListNew:deptListNew})
                    }else{
                        reject("转换出错")
                    }
                })
            })
        },
        amapConvertFromBatchPM(arrList) {
            let lnglats = []
            /*
            let deptListNew = arrList.filter(item => {
                return !isNull(item.longitude)&&!isNull(item.latitude)
            })
            let length = deptListNew.length
            */
            let length = arrList.length
            for(let i = 0;i<length;i++) {
                let data = arrList[i]
                lnglats.push(new AMap.LngLat(data.longitude,data.latitude))
            }
            //this.effecMeterList = deptListNew
            //this.dataSource = deptListNew
            return new Promise(function(resolve,reject){
                AMap.convertFrom(lnglats, "baidu", function (status, result) {
                    if (result.info === 'ok') {
                        // resolve只能处理一个参数
                        resolve({resLnglats:result.locations,deptListNew:arrList})
                    }else{
                        reject("转换出错")
                    }
                })
            })
        },
        addAMapMarker(resLnglat,data) {
            let map = this.map
            //let icon = this.setDeviceStatusIcon(data)
            let icon = ''
            let marker =  new AMap.Marker({
                icon: icon,
                position: resLnglat,
                anchor: 'top-center',
                label: {
                    //content: `<div class='labelContent'>${data.userMeterAddr}</div>`,
                    //offset: new AMap.Pixel(0,-28)
                }
            });
            let that = this
            marker.on('click',function(e){that.queryMeterInfoByLngAndLat(data,resLnglat)});
            //map.add(marker);
            markers.push(marker)
            //return markers;
        },
        addAMapLabelMarker(resLnglat,data) {
            let map = this.map
            let singleText = cloneObject(text)
            let status = this.transMeterStatusInfo(data)
            let markerIcon = icon
            let zIndex = 1
            if(status!=='正常'&&status !== '--') {
                // 有异常时将标记点放置在最上层显示
                markerIcon = unusualIcon
                zIndex = 2
            }
            
            //singleText.content = data.userMeterAddr;
            let labelMarker =  new AMap.LabelMarker({
                icon: markerIcon,
                position: resLnglat,
                anchor: 'top-center',
                //text: singleText,
                zIndex: zIndex,
                extData: data
            });
            let that = this
            labelMarker.on('click',function(e){that.queryMeterInfoByLngAndLat(data,resLnglat)});
            //map.add(marker);
            labelsMarker.push(labelMarker)
        },
        addAMapLabelMarkerPM(resLnglat,data) {
            let map = this.map
            let singleText = cloneObject(text)
            let status = data.warnstatus == 0?'正常':data.datainfo
            let markerIcon = icon
            let zIndex = 1
            console.log("-------------")
            console.log(data.warnstatus!=0)
            if(data.warnstatus!=0) {
                // 有异常时将标记点放置在最上层显示
                markerIcon = unusualIcon
                zIndex = 2
            }
            
            singleText.content = data.deviceLocation;
            let labelMarker =  new AMap.LabelMarker({
                icon: markerIcon,
                position: resLnglat,
                anchor: 'top-center',
                text: singleText,
                zIndex: zIndex,
                extData: data
            });
            let that = this
            labelMarker.on('click',function(e){that.queryPMMeterInfoByLngAndLat(data,resLnglat)});
            //map.add(marker);
            labelsMarker.push(labelMarker)
        },
        queryMeterInfoByLngAndLat(data,resLnglat) {
            console.log(data)
            getAction(this.url.queryMeterInfoByLngAndLat,{lng: data.userMeterLng,lat: data.userMeterLat}).then((res)=> {
                if(res.success) {
                    if(res.result.length>0) {
                        this.showInfoM(res.result,resLnglat)
                    }
                }
            })
        },
        queryPMMeterInfoByLngAndLat(data,resLnglat) {
            console.log(data)
            getAction(this.url.queryPMMeterInfoByLngAndLat,{lng: data.longitude,lat: data.latitude}).then((res)=> {
                if(res.success) {
                    let length = res.result.length;
                    if(length>0) {
                        let result = res.result
                        this.showInfoPM(result,resLnglat)
                    }
                }
            })
        },
        showInfoM(meterArr,position){
            let map = this.map
            let deptPhoto = "";
            let str = '<div class="amapInfo">'
            str+=`<a-icon id="closeInfo${position.lat}" type="close-circle" class="closeInfo" >${this.$t('关闭')}</a-icon>`
            str+=`<table class="infoWindow">`
            str+=`<tr><th>${this.$t('设备编号')}</th><th>${this.$t('用户姓名')}</th><th>${this.$t('联系电话')}</th><th>${this.$t('表安装地址')}</th><th>${this.$t('阀门状态')}</th><th>${this.$t('运行状态')}</th></tr>`
            for(let i = 0;i<meterArr.length;i++) {
                let status = this.transMeterStatusInfo(meterArr[i])
                let valveStatus= this.$t('开阀')
                if(!isUndefinedAndNull(meterArr[i].meterValveStatus)) {
                    valveStatus=this.$t(Mn100FkStatusObj[meterArr[i].meterValveStatus])
                }
                let data = meterArr[i]
                str+=`<tr>`
                str+=`<td>${meterArr[i].meterId}</td>`
                str+=`<td>${data.userName?data.userName:'--'}</td>`
                str+=`<td>${data.userPhone?data.userPhone:'--'}</td>`
                str+=`<td>${data.userMeterAddr?data.userMeterAddr: '--'}</td>`
                str+=`<td>${!isNull(data.meterValveStatus)?valveStatus: '--'}</td>`
                str+=`<td>${this.$t(status=='正常'?'正常':status=='--'?'--':'异常')}</td>`
                str+=`</tr>`
            }
            str+='</table></div>'
            var infoWindow = new AMap.InfoWindow({
                isCustom: true,  //使用自定义窗体
                content: str,
                //offset: new AMap.Pixel(16, -45)
            });
            infoWindow.open(map, position);
            setTimeout(() => {
            let that = this
            let closeInfoobj = document.getElementById('closeInfo'+position.lat);
            let meterObj = document.getElementById(position.lat);
            if(meterObj != null) {
                meterObj.onclick = function () {
                    //that.goIndex(params)
                }
            }
            closeInfoobj.onclick = function () {
                infoWindow.close()
            };
            },500)
        },
        showInfoPM(meterArr,position){
            let map = this.map
            let deptPhoto = "";
            let str = '<div class="amapInfo">'
            str+=`<a-icon id="closeInfo${position.lat}" type="close-circle" class="closeInfo" >${this.$t('关闭')}</a-icon>`
            str+=`<table class="infoWindow" style="width: 100%">`
            str+=`<tr><th>${this.$t('设备编号')}</th><th>${this.$t('设备名称')}</th><th>${this.$t('表安装地址')}</th><th>${this.$t('运行状态')}</th></tr>`
            for(let i = 0;i<meterArr.length;i++) {
                let status = meterArr[i].status == 0?this.$t('正常'):meterArr[i].datainfo
                let data = meterArr[i]
                str+=`<tr>`
                str+=`<td>${meterArr[i].meterid}</td>`
                str+=`<td>${data.deviceName?data.deviceName:'--'}</td>`
                str+=`<td>${data.deviceLocation?data.deviceLocation: '--'}</td>`
                str+=`<td>${status}</td>`
                str+=`</tr>`
            }
            str+='</table></div>'
            var infoWindow = new AMap.InfoWindow({
                isCustom: true,  //使用自定义窗体
                content: str,
                //offset: new AMap.Pixel(16, -45)
            });
            infoWindow.open(map, position);
            setTimeout(() => {
            let that = this
            let closeInfoobj = document.getElementById('closeInfo'+position.lat);
            let meterObj = document.getElementById(position.lat);
            if(meterObj != null) {
                meterObj.onclick = function () {
                    //that.goIndex(params)
                }
            }
            closeInfoobj.onclick = function () {
                infoWindow.close()
            };
            },500)
        },
        transMeterStatusInfo(data) {
            let batteryStatus = ''
            if(data.meterBatteryStatus===1) {
                batteryStatus = '欠压'
            }
            let magneticStatus = ''
            if(data.meterMagnetic===1) {
                magneticStatus='有磁干扰'
            }
            let valveFaultStatus = ''
            if(data.meterValveFault === 1) {
                valveFaultStatus = '阀门故障'
            }
            let status = ''
            if(batteryStatus !== '') {
                if(status.length>0) {
                    status+=','+batteryStatus
                }else{
                    status=batteryStatus
                }
            }
            if(magneticStatus!=='') {
                if(status.length>0) {
                    status+=','+magneticStatus
                }else{
                    status=magneticStatus
                }
            }
            if(valveFaultStatus !== '') {
                if(status.length>0) {
                    status+=','+valveFaultStatus
                }else{
                    status=valveFaultStatus
                }
            }
            if(isNull(data.meterBatteryStatus)||isNull(data.meterMagnetic)||isNull(data.meterValveFault)) {
                status = '--'
            }else if(status == ''||status.length==0) {
                status = '正常'
            }
            return status
        },
        changeSystemDeviceType() {
            //
            if(this.systemDeviceType == 2) {
                // 压力
                //this.dataSource = this.pmEffecMeterList;
                this.loadPMData(1);
                this.effecMeterList = this.pmEffecMeterList;
                labelsMarker = [];
                labelsLayer.clear();
                if(this.pmEffecMeterList.length>0) {
                    this.dealAMapMarkersPM(this.pmEffecMeterList);
                }else{
                    this.ipagination = this.$options.data.call(this).ipagination
                    this.queryPMDeviceInfoAndDeviceUpData()
                }
                
            }else if(this.systemDeviceType == 3) {
                // 压力
                //this.dataSource = this.pmEffecMeterList;
                this.loadWMData(1);
                labelsMarker = [];
                labelsLayer.clear();
                this.ipagination = this.$options.data.call(this).ipagination
                this.queryPMDeviceInfoAndDeviceUpData()
                
                
            }else{
                // 水表
                //this.dataSource = this.waterEffecMeterList;
                this.loadData(1);
                this.effecMeterList = this.waterEffecMeterList;
                labelsMarker = [];
                labelsLayer.clear();
                if(this.waterEffecMeterList.length>0) {
                    this.dealAMapMarkers(this.waterEffecMeterList);
                }else{
                    this.ipagination = this.$options.data.call(this).ipagination
                    this.queryMeterInfoAndMeterUpData()
                }
                
            }
        }
    }
}
</script>
<style lang="less" scoped>
.index-container{
    height: 100vh;
    background: url('~@/assets/images/bg.png') #08092D repeat;
    overflow: hidden;
}
.echarts {
    height: 100%;
}
.theme-color{
    color: #00FAFE;
}
.theme-color.theme-font{
    font-size: 30px;
    letter-spacing: -0.18px;
}
.header-row-line{
    background-image: linear-gradient(0deg, rgba(0,4,57,0.00) 0%, #00053A 100%);
}
.header{
    background: url('~@/assets/images/header.png') #000439 no-repeat;
    background-size: 100% 100%;
    padding-top: 7.3px;
    padding-bottom: 7.3px;
}
.ant-spin-nested-loading /deep/ .ant-spin-container{
    height: 100%
}
.tabs{
    display: flex;
    margin-left: 41px;
}
.tab{
    padding: 8px 16px;
    margin: 0 15px 0 0;
    
    cursor: pointer;
}
.tab-active{
    position: relative;
}
.tab-active::before{
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    content: '';
    height: 2px;
    background-color: #65CDE4;
    transition: all .3s;

}
.tab:last-child {

    margin-right: 0;
}
.tab-title{
    font-size: 18px;
    color: #ffffff;
    cursor: pointer;
}
.tab-active .tab-title{
    color: #6ED9F2;
    position: relative;
}
.header-right{
    margin-right: 27px;
    padding: 16px;
}
.right-time{
    color: #ffffff;
}
.right-time .time{
    font-size: 22px;
}
/* 每块内容的样式 */
.index-main{
    /deep/ .m-panel{
        color: #ffffff;
        height: 100%;
    }
}
.item .iconfont{
    font-size: 30px;
}
</style>
<style>
    /*高德地图信息窗口样式开始 */
    .amap-info-contentContainer{
        width: 550px;
        background: rgba(0,0,0,0.7);
        border: 1px solid #32C5FF;
    }
    .amapInfo{
        color: #2BBDFB;
        padding: 20px;
        padding-top: 30px;
        background: linear-gradient(
            270deg
            ,#31D7FF,#31D7FF) 100% 0 no-repeat,linear-gradient(
            180deg
            ,#31D7FF,#31D7FF) 100% 0 no-repeat;
        background-size: 5px 18px,18px 5px;
        position: relative;
    }
    .amapInfo .closeInfo{
        position: absolute;
        cursor: pointer;
        top: 8px;
        right: 15px;
        color: #85A9DF;
        font-size: 14px;
    }
    .amapInfo .deptImg{
        border: 0.5px solid #2BBDFB;
        padding: 12px;
        position: relative;
    }
    .amapInfo .deptImg:after{
        position: absolute;
        content: '';
        left: -3px;
        right: -3px;
        top: -3px;
        bottom: -3px;
        background: linear-gradient(
                270deg
                ,#31D7FF,#31D7FF) 0 0 no-repeat,linear-gradient(
                180deg
                ,#31D7FF,#31D7FF) 0 0 no-repeat,linear-gradient(
                270deg
                ,#31D7FF,#31D7FF) 100% 0 no-repeat,linear-gradient(
                180deg
                ,#31D7FF,#31D7FF) 100% 0 no-repeat,linear-gradient(
                270deg
                ,#31D7FF,#31D7FF) 0 100% no-repeat,linear-gradient(
                180deg
                ,#31D7FF,#31D7FF) 0 100% no-repeat,linear-gradient(
                270deg
                ,#31D7FF,#31D7FF) 100% 100% no-repeat,linear-gradient(
                270deg
                ,#31D7FF,#31D7FF) 100% 100% no-repeat;
        background-size: 6px 6px,6px 6px,6px 6px,6px 6px;
    }
    .amapInfo a{
        color: #28E8FB;
        font-weight: 500;
    }
    .amapInfo a:hover{
        color: #00fbff!important;
    }
    .amapInfo .deptImg img:focus{
        outline: unset;
    }
    .amapInfo .infoWindow td,.amapInfo .infoWindow th{
        border-bottom: 1px solid #85A9DF;
        padding: 8px;
        word-break:break-all; 
        overflow:auto;
    }
    .amapInfo .infoWindow th{
        word-break: keep-all;
        white-space:nowrap;
        position: relative;
    }
    .amapInfo .infoWindow th:not(:first-child):before {
        position: absolute;
        content: "";
        left: 0;
        top: 8px;
        bottom: 0;
        width: 1px;
        margin: 3px 0;
        background: #9eb5ff;
    }
    .amapInfo .infoWindow th:not(:last-child):after {
        position: absolute;
        content: "";
        right: 0;
        top: 8px;
        bottom: 0;
        width: 1px;
        margin: 3px 0;
        background: #3e66e7;
    }
    .amap-marker-label{
        background :#041741;
        color: #31D7FF;
        border-radius: 3px;
        border: 1px solid #31D7FF;
    }
    /*高德地图信息窗口样式结束 */
    .keyWordSearh.ant-select-dropdown{
        background-color: rgba(2,31,95,0.8);
    }
    .keyWordSearh .ant-select-dropdown-menu-item{
        color: #fff;
    }
    .keyWordSearh .ant-select-dropdown-menu-item-selected{
        background-color: #021F5F;
    }
    .keyWordSearh .ant-select-dropdown-menu-item:hover:not(.ant-select-dropdown-menu-item-disabled){
        background-color: #021F5F;
        color: #85A9DF;
    }
    .keyWordSearh .ant-select-dropdown-menu-item-selected{
        color: #85A9DF;
    }
</style>